<template>
  <div class="image-blow">
    <img
      class="origin-img"
      src="https://ossuat.plantmate.com/commonAttachment/1614059248398/01.jpg"
      alt=""
    />
    <div class="b-blow">
      <img
        class="blow-img"
        src="https://ossuat.plantmate.com/commonAttachment/1614059248398/01.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {

}
</script>
<style lang="scss" scoped>
.image-blow {
  position: relative;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    &.origin-img {
      cursor: url('../../../../assets/img/scene-blow.png'), auto;
    }
  }
  .b-blow {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 100%;
    top: 0;
  }
}
</style>
